"use client";

import { ReviewsRow } from "../ReviewsRow";

export function CompanyNameStep({
  value,
  onChange,
  onContinue,
  onSkip,
}: {
  value: string;
  onChange: (value: string) => void;
  onContinue: () => void;
  onSkip: () => void;
}) {
  const canContinue = value.trim().length > 0;

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        if (canContinue) onContinue();
      }}
      // Vertically centred on phones, as on the intro step. 134px is the nav
      // (64) plus StepShell's sticky header (~70) — this step has both above
      // it. min-h so a taller phone layout still grows and scrolls; symmetric
      // py so the centring isn't skewed.
      className="mx-auto flex min-h-[calc(100dvh-134px)] w-full max-w-[932px] flex-col items-start justify-center gap-6 px-4 py-8 sm:min-h-0 sm:justify-start sm:gap-8 sm:px-6 sm:pb-24 sm:pt-12 lg:pt-[93px]"
    >
      <h1 className="font-suisse-intl-bold text-[32px] leading-tight text-white sm:text-5xl lg:text-[56px] lg:leading-[71px]">
        Choose your company name
      </h1>

      <p className="font-suisse-intl text-base leading-relaxed text-white sm:text-lg sm:leading-[28.8px]">
        Your company name must be unique and approved by the Hong Kong Companies Registry.{" "}
        <br className="max-sm:hidden " />
         <br className="max-sm:hidden " />
        Enter a preferred name and we&apos;ll check availability during registration.
      </p>

      <ReviewsRow />

      <div className="flex w-full flex-col items-start gap-5 sm:gap-6">
        <div className="flex w-full flex-col items-start gap-4">
          <input
            type="text"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder="Enter your company name"
            aria-label="Company name"
            className="h-14 w-full rounded-[34px] bg-white/20 px-5 font-suisse-intl text-base text-white outline outline-2 -outline-offset-2 outline-white/[0.04] backdrop-blur-xl placeholder:text-white/50 focus:outline-white/30 sm:px-[25px]"
          />

          {/* text-left + leading so the label wraps cleanly on narrow phones
              instead of dragging the chevron onto its own line. */}
          <button
            type="button"
            onClick={onSkip}
            className="inline-flex items-start gap-2 text-left font-suisse-intl text-base leading-6 text-[#0061FE] transition-opacity hover:opacity-80 sm:items-center sm:text-lg sm:leading-4"
          >
            Skip for now, I haven&apos;t decided yet
            <svg
              viewBox="0 0 16 16"
              // mt only while items-start applies, to sit on the first line
              // rather than its top edge.
              className="mt-1 h-4 w-4 shrink-0 sm:mt-0"
              aria-hidden="true"
            >
              <path
                d="M6 3.5l5 4.5-5 4.5"
                fill="none"
                stroke="#0061FE"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>

        <button
          type="submit"
          disabled={!canContinue}
          className="flex h-14 w-full items-center justify-center rounded-full bg-white px-4 font-suisse-intl text-xl leading-5 text-[#2A4775] transition-opacity hover:opacity-90 disabled:pointer-events-none disabled:opacity-50"
        >
          Continue
        </button>
      </div>
    </form>
  );
}
